import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { LocalDataSource } from 'ng2-smart-table';
import { Subscription } from 'rxjs';
import { BrandDTO, CategoryDTO, CollectionDTO, ColorDTO, dropdown, Image1DTO, ImageDTO, ProductImgDTO, ProductsDTO, SizeDTO, SubCategoryDTO, TagDTO, VariantDTO } from 'src/app/shared/models/model';
import { colorService } from 'src/app/shared/service/color.service';
import { NotificationService } from 'src/app/shared/service/notification.service';
import { productService } from 'src/app/shared/service/product.service';
import { sizeService } from 'src/app/shared/service/size.service';
import { variantService } from 'src/app/shared/service/variant.service';

//



@Component({
  selector: 'app-add-variant',
  templateUrl: './add-variant.component.html',
  styleUrls: ['./add-variant.component.scss']
})
export class AddVariantComponent implements OnInit{

  //

  
  public editorValue: string = '';
  public Source: LocalDataSource;
  public countryForm: FormGroup;
  public subcategoryForm: FormGroup;
  public closeResult: string;
  public categoryList: CategoryDTO[] = [];
  public subcategoryList: SubCategoryDTO[] = [];
  public collectionList: CollectionDTO[] = [];
  public brandList: BrandDTO[] = [];
  public tagList: TagDTO[] = [];
  public productsList: ProductsDTO[] = [];
  public productDTO: ProductsDTO;
  public subcategoryDTO: SubCategoryDTO[];
  public subcategoryobject: SubCategoryDTO;
  public productobject: ProductsDTO;
  public productForm: FormGroup;
  public counter: number = 1;
  public subcategoriesVisible: boolean;
  public img:ImageDTO;
  public a: any;
  public ImageArray:Image1DTO[]=[];
  public Image1 = new Image1DTO();
  public ImagesProductList:ProductImgDTO[]=[];
  public formData:FormData=new FormData();
  public formDataArray:FormData[]=[];
  public dropDownTag: dropdown[] = [];
  public dropDownBrand: dropdown[] = [];
  public dropDownCollection: dropdown[] = [];
  public dropDownSubcategory: dropdown[] = [];
  public dropDownCategory: dropdown[] = [];
  public dropDownSale: dropdown[] = [];
  public dropDown: dropdown[] = [];
  public fileReader:FileReader=new FileReader();
  //

  public VariantDTO:VariantDTO;
  public colorList: ColorDTO[] = [];
  public sizeList: SizeDTO[] = [];
  public dropDownColor: dropdown[] = [];
  public dropDownSize: dropdown[] = [];
  public variantForm: FormGroup;
  public VariantDTOList:VariantDTO[];
  public id:any;
  public count:number=0;
  public IsColorEnabled=false;

  private formSubscription: Subscription;

  addRecord(event){
    debugger
    this.VariantDTO= new VariantDTO;
    this.VariantDTO.Sku=event.newData.Sku;
    this.VariantDTO.Price=event.newData.Price;
    this.VariantDTO.CodeProduct=event.newData.ProductsIdproductNavigation;
    this.VariantDTO.Quantity=event.newData.stock;
    this.VariantDTO.New=event.newData.New;

    console.log(this.VariantDTO);

    console.log(event);
    event.confirm.resolve(event.newData);


  }


  public settings = {
    "mode": "inline",
    delete: {
      "confirmDelete": "true" ,
    },
    edit: { "confirmSave": "true" },
    add:{
      "confirmCreate":"true"
 },
    actions: {
      position: 'right',
      update: false,
      add:true,
    },
    columns: {
      id:{
        title: 'Id',
        width: '0.5%',
        editable: false //
      },
      sku: {
        title: 'Sku',
        width: '30%', // Auto-sizing
      },
      price:{
        title: 'Price',
        width: '10%', //
      },
      new:{
        title: 'New',
        valuePrepareFunction: (cell, row) => {
          return row.new== "true" ? "Yes": "No";
        },
          editable: true,
          width: 'auto', // Auto-sizing
      },
      ProductsIdproductNavigation: {
        title: 'Product',
        valuePrepareFunction: (cell, row) => {
          return row.codeProductNavigation.title;
        },
          editable: false,
          width: 'auto', // Auto-sizing
      },
      colorIdColorNavigation: {
        title: 'Color',
        valuePrepareFunction: (cell, row) => {
          return row.colorIdColorNavigation?.description || '';
        },
        editable: this.IsColorEnabled,
        editor: {
          type: 'list',
          config: {
            selectText: 'Select',
            list: this.dropDownColor
          },
        }
      },sizeIdSizeNavigation: {
        title: 'Size',
        valuePrepareFunction: (cell, row) => {
          return row.sizeIdSizeNavigation.size1;
        },
        editor: {
        type: 'list',
        config: {
          selectText: 'Select',
          list: this.dropDownSize,
        },
        editable: true,
      }
      }
    },
  };

  

  public url = [{
    img: "assets/images/user.png",
    del:"",
    id:0
  },
  {
    img: "assets/images/user.png",
    del:"",
    id:0
  },
  {
    img: "assets/images/user.png",
    del:"",
    id:0
  },
  {
    img: "assets/images/user.png",
    del:"",
    id:0
  },
  {
    img: "assets/images/user.png",
    del:"",
    id:0
  }
  ];


  /**
   *
   */
  constructor(private fb: FormBuilder,private color: colorService, private size: sizeService,private variant:variantService,private productService:productService,private route: ActivatedRoute,private notifcationService: NotificationService) {
   debugger
    this.id = this.route.snapshot.params.id;
    var validationcolor=false;
      

      this.getVariant();
      this.getProductsImg();
      this.getColorStatus();
      if(this.IsColorEnabled){
        validationcolor=true;
      }else{
        validationcolor=false;

      }

        this.color.getColors().subscribe(data => {

          this.colorList = data;
          console.log(this.colorList);
          var dropDown = new dropdown();
          this.colorList.forEach(element => {
            dropDown.value = element.idColor;
            dropDown.title = element.description;
            console.log("element =>",element);
            this.dropDownColor.push(
              {
                title: dropDown.title,
                value: dropDown.value,
              }
            )
          })
          var c = new ColorDTO();
          c.description = "";
          c.idColor = -1;
          // Explicitly set the form control to null
          this.variantForm.controls['color'].setValue(c, { emitEvent: false });
    
          this.settings = Object.assign({}, this.settings);
        });



    this.size.getAllSizes().subscribe(data => {
      this.sizeList = data;
      console.log(this.sizeList);
      var dropDown = new dropdown();
      this.sizeList.forEach(element => {
        dropDown.value = element.idSize;
        dropDown.title = element.size1;
        this.dropDownSize.push(
          {
            title: dropDown.title,
            value: dropDown.value,
          }
        )
      })

      var s = new SizeDTO();
      s.size1 = "";
      s.idSize = -1;
      // Explicitly set the form control to null
      this.variantForm.controls['size'].setValue(s, { emitEvent: false });
      this.settings = Object.assign({}, this.settings);
    });
    var initSize= new SizeDTO;
    initSize.idSize=0;
    initSize.size1="No Size";
    this.sizeList.fill(initSize);

    console.log("validation color is ",  validationcolor);


    this.variantForm = this.fb.group({
      description: ['',Validators.required],
      descriptiones: ['', Validators.required],
      descriptionfr: ['', Validators.required],
      color: [null, validationcolor],
      size: [''],
      price: ['', [
        Validators.required,
        Validators.min(1),
        Validators.max(100000),
        Validators.pattern(/^\d{1,5}(\.\d{1,2})?$/)  // up to 2 decimal places
      ]],
      qte: ['', [
        Validators.required,
        Validators.min(1),
        Validators.max(9999),
        Validators.pattern(/^\d+$/)  // Optional: extra protection to ensure digits only
      ]],
      new: ['', Validators.required],
    });

    
  }
  ngOnInit(){
    debugger
    this.formSubscription = this.variantForm.valueChanges.subscribe(formData => {
      console.log("value => ",formData);
      // Store the form data in sessionStorage whenever it changes
      sessionStorage.setItem('formData', JSON.stringify(formData));
    });

    // Check if there's data in sessionStorage and pre-populate the form
    const storedData = sessionStorage.getItem('formData');
    if (storedData) {
      const formData = JSON.parse(storedData);
      this.variantForm.patchValue(formData);
    }
  }

  getVariant(){
    this.variant.getVariant(this.id).subscribe(data => {
      this.VariantDTOList=data;
      this.Source = new LocalDataSource(this.VariantDTOList);
      console.log("Variants ",this.Source);
    });
  }

  getProductsImg(){
    debugger
    this.variant.getImgProduct(this.id).subscribe(data => {
      console.log("ID IS", this.id);
      this.ImagesProductList = data;
      console.log("Image product list",this.ImagesProductList);

      this.ImagesProductList.forEach(data => {
        this.url[this.count].img = "assets/images/digital-product/" + data.name;
        this.url[this.count].del = "assets/images/delete.png";
        this.url[this.count].id = data.idimage;
        this.count++;
      });
  }
)}
  getColorStatus(): boolean {
    debugger
    this.color.getColorStatus(this.id).subscribe(response => {
      console.log("status color",  response);

      this.IsColorEnabled = response.result;
    });
    return this.IsColorEnabled;
  }

allowOnlyNumbers(event: KeyboardEvent) {
  const charCode = event.which ? event.which : event.keyCode;

  // Allow only digits (0-9)
  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
    return;
  }

  // Now get the current value and append the new digit
  const input = event.target as HTMLInputElement;
  const nextValue = input.value + String.fromCharCode(charCode);
  const numericValue = Number(nextValue);

  // Block if number is out of range
  if (numericValue < 1 || numericValue > 9999) {
    event.preventDefault();
  }
}

allowOnlyNumbersForPrice(event: KeyboardEvent) {
  const input = event.target as HTMLInputElement;
  const currentValue = input.value;
  const char = event.key;

  // Allow control/navigation keys
  if (
    ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(char)
  ) {
    return;
  }

  // Allow only digits and a single decimal point
  if (!/^\d$/.test(char) && !(char === '.' && !currentValue.includes('.'))) {
    event.preventDefault();
    return;
  }

  // Simulate next value
  const nextValue = currentValue + char;

  // Validate format: up to 5 digits before decimal and up to 2 digits after
  if (!/^\d{0,5}(\.\d{0,2})?$/.test(nextValue)) {
    event.preventDefault();
    return;
  }

  // Convert to number and validate range
  const numericValue = parseFloat(nextValue);
  if (numericValue < 1 || numericValue > 100000) {
    event.preventDefault();
  }
}
  updateRecord(e){
     debugger
    e.confirm.resolve(e.newData);
    this.VariantDTO=new VariantDTO();

    if (e.newData.colorIdColorNavigation?.["idColor"] === undefined) {
      this.VariantDTO.ColorIdColor = e.newData.colorIdColorNavigation;
    }else{
      this.VariantDTO.ColorIdColor = e.newData.colorIdColorNavigation?.["idColor"];
    }

    if(e.newData.sizeIdSizeNavigation==="-2"){
      this.VariantDTO.SizeIdSizeNavigation=null;
    }
    
    if (e.newData.sizeIdSizeNavigation !== "-2") {
      if (e.newData.sizeIdSizeNavigation?.["idSize"] === undefined) {
        this.VariantDTO.SizeIdSize = e.newData.sizeIdSizeNavigation;
      } else {
        this.VariantDTO.SizeIdSize = e.newData.sizeIdSizeNavigation?.["idSize"];
      }
    }

 
    const parsedPrice = Number(e.newData.price);

    if (isNaN(parsedPrice) || parsedPrice < 1 || parsedPrice > 9999) {
      this.notifcationService.showError("Variant", "Price Format invalide");
      e.newData.price = 0;
      return;
    } else {
      this.VariantDTO.Price = parsedPrice;
    }

    this.VariantDTO.Descriptionvariant= e.newData.descriptionvariant;
    this.VariantDTO.Id= e.newData.id;
    this.VariantDTO.Sku=e.newData.sku;
    this.variant.updateVariant(this.VariantDTO);
    e.confirm.resolve();
  }

  deleteRecord(e){
    this.VariantDTO=new VariantDTO();
    this.VariantDTO.Id= e.data.id;
    this.variant.deleteVariant(this.VariantDTO.Id);
    e.confirm.resolve();
  }

  saveVariant(variantForm){
    debugger
    let id = this.route.snapshot.params.id;
    console.log("codeproduct");
    console.log(id);
    this.VariantDTO = new VariantDTO();
    this.VariantDTO.New=false;
    this.VariantDTO.CodeProductNavigation=new ProductsDTO();
    this.VariantDTO.CodeProduct=id;
    this.VariantDTO.CodeProductNavigation.CodeProduct=id;
    this.VariantDTO.Price=variantForm.controls['price'].value;
    this.VariantDTO.New=variantForm.controls['new'].value;
    this.VariantDTO.Descriptionvariant=variantForm.controls['description'].value;
    this.VariantDTO.Fr_Descriptionvariant=variantForm.controls['descriptionfr'].value;
    this.VariantDTO.Es_Descriptionvariant=variantForm.controls['descriptiones'].value;
    this.VariantDTO.SizeIdSizeNavigation=new SizeDTO(); 
    this.VariantDTO.SizeIdSizeNavigation=variantForm.controls['size'].value;
    this.VariantDTO.SizeIdSize=variantForm.controls['size'].value;

    // if (this.VariantDTO.SizeIdSizeNavigation.size1 == "" || this.variantForm.controls['size'].value == -2 ) {
    //    this.VariantDTO.SizeIdSize=null;
    // }

     debugger

    if(this.IsColorEnabled){
      this.VariantDTO.ColorIdColorNavigation=new ColorDTO(); 
      this.VariantDTO.ColorIdColorNavigation=variantForm.controls['color'].value;
      if (this.VariantDTO.ColorIdColorNavigation.description == "") {
        this.variantForm.get('color').setErrors({ colorForbidden: this.IsColorEnabled });
      } else {
        this.VariantDTO.ColorIdColor = this.VariantDTO.ColorIdColorNavigation.idColor;
      }
    }
   
    this.VariantDTO.Quantity=variantForm.controls['qte'].value;

    if (this.variantForm.invalid) {
      console.log("Form is invalid. Submission stopped.");
      for (const controlName in this.variantForm.controls) {
        const control = this.variantForm.get(controlName);
        if (control && control.invalid) {
          console.log(`Control '${controlName}' is invalid. Errors:`, control.errors);
        }
      }
      return; // Prevent further processing
    }

    this.VariantDTO.ColorIdColorNavigation=null;
    this.VariantDTO.SizeIdSizeNavigation=null;
    this.variant.addVariant(this.VariantDTO);
  }
  keepsession(){
    sessionStorage.setItem('formData', JSON.stringify(this.variantForm.value));
  }


  readFile(file: File) {
    debugger
    const reader = new FileReader();
    reader.onload = (_event) => {
      const dataURL: string | ArrayBuffer | null = reader.result;
      if (typeof dataURL === 'string') {
        // Extract base64 string from data URL
        const base64String = this.extractBase64FromDataURL(dataURL);
        this.Image1.name = file.name;
        this.Image1.blobValue = base64String;
        this.Image1.codeProduct = this.id;
        this.upload(this.Image1,event);
      }
    };
    reader.readAsDataURL(file);
  }
  upload(imageDTO:Image1DTO,event:any){
    debugger
    this.productService.addImages(this.Image1, event);
    
  }

  
  //FileUpload
  readUrl(event: any, i) {
    debugger
    if (event.target.files.length === 0)
      return;
    //Image upload validation
    var mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    // Image upload
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    this.readFile(event.target.files[0]);

    reader.onload = (_event) => {
      this.url[i].img = reader.result.toString();
      this.url[i].del="assets/images/delete.png";
      // this.Image1.name=file.name;
      // this.Image1.blobValue=this.url[i].img;
      // this.Image1.codeProduct=this.id;
      console.log("uploaded img to insert");
      console.log(this.url[i]);
    }
    console.log("=====>");
    console.log(this.Image1);
  }
  extractBase64FromDataURL(dataURL: string): string {
    return dataURL.split(',')[1];
  }

  deletImg(event: any, i) {
    debugger
    var t = this.variant.deleteImg(i.id);
  }
}